import { api } from './api';

// Define a service using a base URL and expected endpoints
export const aiApi = api.injectEndpoints({
  reducerPath: 'aiApi',
  tagTypes: ['Ner'],
  endpoints: (builder) => ({
    ner: builder.mutation({
      query: ({ text, tags, exclusions, type }) => ({
        url: `api/ai/ner`,
        method: 'POST',
        body: { text, tags, exclusions, type },
        providesTags: ['Ner']
      })
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useNerMutation } = aiApi;
